const ERROR_MESSAGES = {
  GET_NOTIFICATIONS:
    'Unfortunately, there was an error getting your settings. Please try again later.',
  GET_NOTIFICATIONS_TIMEOUT:
    'Unfortunately, there was an error getting your settings. Please try again in a few minutes.',
  GET_SOFTPULL_CONSENT:
    'Unfortunately, there was an error getting your Credit Monitoring settings. Please try again later.',
  GET_SOFTPULL_CONSENT_TIMEOUT:
    'Unfortunately, there was an error getting your Credit Monitoring settings. Please try again in a few minutes',
  UPDATE_CREDIT_MONITORING:
    'Unfortunately, there was an error updating your Credit Monitoring. Please try again later.',
  UPDATE_CREDIT_MONITORING_TIMEOUT:
    'Unfortunately, there was an error updating your Credit Monitoring. Please try again in a few minutes.',
  UPDATE_EMAIL:
    'Unfortunately, there was an error updating your Email notifications. Please try again later.',
  UPDATE_EMAIL_TIMEOUT:
    'Unfortunately, there was an error updating your Email notifications. Please try again in a few minutes.',
  UPDATE_SMS:
    'Unfortunately, there was an error updating your Text notifications. Please try again later.',
  UPDATE_SMS_TIMEOUT:
    'Unfortunately, there was an error updating your Text notifications. Please try again in a few minutes.',
  UPDATE_PHONE:
    'Unfortunately, there was an error updating your Call notifications. Please try again later.',
  UPDATE_PHONE_TIMEOUT:
    'Unfortunately, there was an error updating your Call notifications. Please try again in a few minutes.',
  UPDATE_PHONE_AND_SMS:
    'Unfortunately, there was an error updating your Call and Text notifications. Please try again later.',
  UNSUBSCRIBE_FROM_ALL:
    'Unfortunately, there was an error unsubscribing you from all notifications. Please try again later.',
  UNSUBSCRIBE_FROM_ALL_TIMEOUT:
    'Unfortunately, there was an error unsubscribing you from all notifications. Please try again in a few minutes.',
  SUBSCRIBE_TO_ALL:
    'Unfortunately, there was an error subscribing you to all notifications. Please try again later.',
  SUBSCRIBE_TO_ALL_TIMEOUT:
    'Unfortunately, there was an error subscribing you to all notifications. Please try again in a few minutes.'
};

export default ERROR_MESSAGES;
